import { useState } from 'react';

export function useSubmit(submitFunction) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  async function submit() {
    try {
      setLoading(true);

      const currentResponse = await submitFunction();

      setResponse(currentResponse?.data);
      setError(null);
    } catch (errorResponse) {
      setError(errorResponse);
    } finally {
      setLoading(false);
    }
  }

  const result = [submit, response, loading, error !== null, error];

  result.isSubmiting = loading;
  result.hasError = error !== null;
  result.error = error;
  result.response = response;
  result.submit = submit;

  return result;
}
